storefrontApp.service("shippingService", [
    "$http",
    "$window",
    function (
        $http,
        $window
    ) {
        function toArray(value) {
            if (!value) {
                return [];
            }
            return angular.isArray(value) ? value : [value];
        }

        function normalizeOrderLineItem(item) {
            if (!item) {
                return item;
            }
            item.id = item.id || item.Id;
            item.name = item.name || item.Name;
            item.sku = item.sku || item.Sku;
            item.quantity = item.quantity || item.Quantity || 1;
            item.definitionName =
            item.definitionName ||
            item.DefinitionName ||
            item.productDefinition ||
            item.ProductDefinition ||
            "";
        item.productType = item.productType || item.ProductType || "";
        item.placedPrice = item.placedPrice || item.PlacedPrice;
        item.extendedPrice = item.extendedPrice || item.ExtendedPrice;
        item.discounts = item.discounts || item.Discounts || [];
        item.orderLevelDiscountAmount =
            item.orderLevelDiscountAmount ||
            item.OrderLevelDiscountAmount || {
                internalAmount: 0,
                amount: 0,
            };
        item.instantLetteringItems =
            item.instantLetteringItems || item.InstantLetteringItems || [];
        item.cartLineItemCustomProperties =
            item.cartLineItemCustomProperties ||
            item.CartLineItemCustomProperties ||
            [];
        item.giftCardItems = item.giftCardItems || item.GiftCardItems || [];
        item.product = item.product || item.Product || {
            vendorId: item.fulfillmentCenterName || item.FulfillmentCenterName || "",
        };
        return item;
        }

        function isDigitalLineItem(item) {
            var type = (
                (item && (item.productType || item.ProductType)) ||
                ""
            ).toLowerCase();
            return type === "digital";
        }

        return {
            getRetryOrderNumber: function () {
                var search = (($window.location && $window.location.search) || "").replace(
                    /^\?/,
                    ""
                );
                if (!search) {
                    return "";
                }
                var match = _.find(search.split("&"), function (param) {
                    return (
                        param &&
                        param.toLowerCase().indexOf("retryorder=") === 0
                    );
                });
                return match ? decodeURIComponent(match.split("=")[1] || "") : "";
            },
            getSavedOrder: function (orderNumber) {
                return $http.get(
                    "storefrontapi/orders/" +
                        encodeURIComponent(orderNumber) +
                        "?t=" +
                        new Date().getTime()
                );
            },
            mapSavedOrderToShippingCart: function (order) {
                var items = _.map(
                    toArray(order && (order.items || order.Items)),
                    normalizeOrderLineItem
                );
                var shipments = toArray(order && (order.shipments || order.Shipments));
                if (!shipments.length) {
                    var allDigital =
                        items.length > 0 &&
                        _.every(items, isDigitalLineItem);
                    var vendor = allDigital ? "Downloadable" : "Shipped";
                    return [
                        {
                            vendor: vendor,
                            city: "",
                            state: "",
                            shipmentGroupKey: vendor,
                            cart: { items: items },
                            productShippingInformation: [
                                {
                                    vendorCode: vendor,
                                    shippingMethodId: allDigital
                                        ? "Free Download"
                                        : "saved",
                                    shippingMethodName: allDigital
                                        ? "Free Download"
                                        : "Saved shipping",
                                    price: { amount: 0 },
                                },
                            ],
                        },
                    ];
                }
                return _.map(shipments, function (shipment) {
                    var shipmentItems = _.map(
                        toArray(shipment.items || shipment.Items),
                        function (shipmentItem) {
                            var lineItemId =
                                shipmentItem.lineItemId ||
                                shipmentItem.LineItemId ||
                                shipmentItem.id ||
                                shipmentItem.Id;
                            return (
                                _.find(items, function (item) {
                                    return (
                                        String(item.id || "").toLowerCase() ===
                                        String(lineItemId || "").toLowerCase()
                                    );
                                }) || normalizeOrderLineItem(shipmentItem)
                            );
                        }
                    );
                    if (!shipmentItems.length) {
                        shipmentItems = items;
                    }
                    var digital =
                        shipmentItems.length > 0 &&
                        _.every(shipmentItems, isDigitalLineItem);
                    var vendor = digital
                        ? "Downloadable"
                        : shipment.fulfillmentCenterName ||
                          shipment.FulfillmentCenterName ||
                          shipment.shipmentMethodOption ||
                          shipment.ShipmentMethodOption ||
                          "Shipped";
                    var methodName =
                        shipment.shipmentMethodName ||
                        shipment.ShipmentMethodName ||
                        (digital ? "Free Download" : "Saved shipping");
                    var price =
                        shipment.price ||
                        shipment.Price ||
                        shipment.sum ||
                        shipment.Sum || { amount: 0 };
                    return {
                        vendor: vendor,
                        city: "",
                        state: "",
                        shipmentGroupKey: vendor,
                        cart: { items: shipmentItems },
                        productShippingInformation: [
                            {
                                vendorCode: vendor,
                                shippingMethodId:
                                    shipment.shipmentMethodCode ||
                                    shipment.ShipmentMethodCode ||
                                    (digital ? "Free Download" : "saved"),
                                shippingMethodName: methodName,
                                price: price,
                            },
                        ],
                    };
                });
            },
            getCountries: function () {
                return $http.get('storefrontapi/countries');
            },
            getCart: function () {
                return $http.get('storefrontapi/cart');
            },
            getShippingInformation: function (address, retryOrderNumber) {
                var url = 'storefrontapi/shipping/productshippinginformation';
                if (retryOrderNumber) {
                    url += '?retryorder=' + encodeURIComponent(retryOrderNumber);
                }
                return $http.post(url, address);
            },
            addOrUpdateMultipleCartShipments: function (shipments) {
                return $http.post('storefrontapi/cart/multipleshipments', shipments);
            },
            updateSavedOrderShipping: function (orderNumber, shipments) {
                return $http.post(
                    "storefrontapi/orders/" +
                        encodeURIComponent((orderNumber || "").toString()) +
                        "/retrycheckout/shipping",
                    shipments
                );
            },
            getShipACDRates: function () {
                return $http.get("storefrontapi/shipping/shipacdrates");
            },
            getShippingFormats: function () {
                return $http.get("storefrontapi/shipping/formats");
            },
            updateShippingMethod: function (shipACD) {
                return $http.post("storefrontapi/shipping/preferredmethod", shipACD);
            }
        }
    }]);
